export const initialState = {
  user: [],
  updateUser: [],
  employees: [],
  clients: [],
  teamleads: [],
  tasks: [],
  jobs: [],
  assignedjobs: [],
  checkinstatus: [],
  blogs: [],
  users: [],
  leaves: [],
  projects: [],
  projectemployees: [],
  selectedtile: "Dashboard",
  projectsupervisors: [],
  allclients: [],
  stripename: "",
  stripeemail: "",
  leadsource: [],
  deals: [],
  listingAppointments: [],
  posts: [],
  postsHasMore: true,
  postsLoading: false,
  postsCursor: null,
  postComments: {},
  emailTemplates: {}, // map keyed by template id; empty means "use defaults everywhere"
  teamDefaults: null, // single team-wide defaults doc (title closer, broker admin fee). null = not yet loaded.
  steps: [
    {
      number: 1,
      title: "Deal Information",
      access: ["Admin", "Employee", "Supervisor", "Accountant"],
    },
    {
      number: 2,
      title: "Client Information",
      access: ["Admin", "Employee", "Supervisor", "Accountant"],
    },
    {
      number: 3,
      title: "Agent & Property",
      access: ["Admin", "Employee", "Supervisor", "Accountant"],
    },
    {
      number: 4,
      title: "Commission",
      description: "Sale Price",
      access: ["Admin", "Supervisor", "Accountant"],
    },
    // {
    //   number: 5,
    //   title: "Splits & Fees",
    // },
    {
      number: 5,
      title: "Review",
      access: ["Admin", "Supervisor", "Accountant"],
    },
  ],
};
